export enum AppMode {
  CREATE = "CREATE",
  EDIT = "EDIT",
  TEST = "TEST", // Test / debug one schema at a time
  TESTS = "TESTS", // Run all automated tests
}
